import { toStreamPartID } from '@streamr/utils';
import { MessageRef } from './MessageRef';
import { validateIsNotNegativeInteger } from './validations';
export class MessageID {
    streamId;
    streamPartition;
    timestamp;
    sequenceNumber;
    publisherId;
    msgChainId;
    constructor(streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId) {
        validateIsNotNegativeInteger('streamPartition', streamPartition);
        validateIsNotNegativeInteger('timestamp', timestamp);
        validateIsNotNegativeInteger('sequenceNumber', sequenceNumber);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
        this.timestamp = timestamp;
        this.sequenceNumber = sequenceNumber;
        this.publisherId = publisherId;
        this.msgChainId = msgChainId;
    }
    getStreamPartID() {
        return toStreamPartID(this.streamId, this.streamPartition);
    }
    toMessageRef() {
        return new MessageRef(this.timestamp, this.sequenceNumber);
    }
}
//# sourceMappingURL=MessageID.js.map